<template>
  <div class="c-card-off">
    <section class="c-card-off__section">
      <div class="c-card-off__img-wrapper">
      </div>
      <div class="c-card-off__info">
        <div class="c-card-off__info-content">
          <img
            src="@/projects/synergy/assets/img/card-off/logo-synergy-id.svg"
            alt="avatar"
            class="c-card-off__info-img"
          />
          <h1 class="c-card-off__info-title">
            Твоя карта заблокирована
          </h1>
          <p class="c-card-off__info-subtitle">
            Мы заметили подозрительную активность и/или не получили подтверждения твоих рекомендаций.
          </p>
          <p class="c-card-off__info-text">
            Монеты временно заморожены — ты не можешь их тратить и получать новые.
          </p>
          <p class="c-card-off__info-text">
            Напиши нам на <a
              href="mailto:help@moicapital.ru"
              class="c-card-off__info-text--color"
            >help@moicapital.ru</a>,
            чтобы поскорее решить ситуацию.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@import './TheCardOff.scss';
</style>
